import textFormatting from '../../text-formatting';

const isNodesFullySelected = () => {
  const selection = textFormatting.accessors.getAdvancedSelection();
  const { anchorNode, anchorOffset, focusNode, focusOffset } = selection;

  return (
    (anchorOffset === 0 && focusNode.length === focusOffset) ||
    (focusOffset === 0 && anchorNode.length === anchorOffset)
  );
};

export default isNodesFullySelected;
